import { render, staticRenderFns } from "./SegmentsRetrieveUpdate.vue?vue&type=template&id=f8e4dade"
import script from "./SegmentsRetrieveUpdate.vue?vue&type=script&lang=js"
export * from "./SegmentsRetrieveUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports